<template>
    <div>
        <Navbar class="bg-white" />
        <PageTitle pageTitle="Computer Vision" />
        <ServicesDetails />
        <Newsletter />
        <Footer />
    </div>
</template>

<script>
import Navbar from '../Layout/Navbar'
import PageTitle from '../Common/PageTitle'
import ServicesDetails from '../SingleService/ServicesDetailsComputerVision'
// import Newsletter from '../Common/Newsletter'
import Footer from '../Layout/Footer'

export default {
    name: 'Services',
    components: {
        Navbar,
        PageTitle,
        ServicesDetails,
        // Newsletter,
        Footer,
    }
}
</script>